// Start the countdown
function startCountdown() {
  const { DateTime } = luxon; // Destructure DateTime from Luxon
  const countdownElement = document.getElementById('countdown-timer');

  if (!countdownElement || countdownElement.classList.contains('loaded')) return;

  // Get values from dataset
  const deadlineTimestamp = parseInt(countdownElement.dataset.deadline) * 1000;
  const deadline = DateTime.fromMillis(deadlineTimestamp).setZone('America/New_York').toUTC();

  // Simulated Date in MilliSeconds
  const simulatedDateMilliSeconds = countdownElement.dataset?.simulatedDate
    ? parseInt(countdownElement.dataset?.simulatedDate) * 1000
    : null;

  // Simulated Date Time
  const simulatedDateTime = simulatedDateMilliSeconds ? DateTime.fromMillis(simulatedDateMilliSeconds).toUTC() : null;

  const daysEl = document.getElementById('days');
  const hoursEl = document.getElementById('hours');
  const minutesEl = document.getElementById('minutes');
  const secondsEl = document.getElementById('seconds');

  let interval; // Declare interval variable here

  // Get the current time in UTC or simulated time
  const now = simulatedDateTime ? simulatedDateTime : DateTime.local().toUTC();

  let initialMsRemaining = deadline.toMillis() - now.toMillis();
  let increment = 1000;

  function updateCountdown() {
    const totalSeconds = Math.floor(initialMsRemaining / 1000);
    const timeRemaining = {
      seconds: totalSeconds % 60,
      minutes: Math.floor((totalSeconds % 3600) / 60),
      hours: Math.floor((totalSeconds % (24 * 3600)) / 3600),
      days: Math.floor(totalSeconds / (24 * 3600)),
    };
    if (
      timeRemaining.days <= 0 &&
      timeRemaining.hours <= 0 &&
      timeRemaining.minutes <= 0 &&
      timeRemaining.seconds <= 0
    ) {
      clearInterval(interval);
      countdownElement.classList.add('hidden');
      return;
    }

    function addLeadingZero(value) {
      return value < 10 ? `0${value}` : value;
    }

    daysEl.textContent = `${addLeadingZero(Math.floor(timeRemaining.days))} : `;
    hoursEl.textContent = `${addLeadingZero(Math.floor(timeRemaining.hours))} : `;
    minutesEl.textContent = `${addLeadingZero(Math.floor(timeRemaining.minutes))} : `;
    secondsEl.textContent = addLeadingZero(Math.floor(timeRemaining.seconds));

    initialMsRemaining -= increment;
  }

  updateCountdown();
  interval = setInterval(updateCountdown, increment); // Assign interval here

  countdownElement.classList.add('loaded');
}

document.addEventListener('DOMContentLoaded', () => {
  startCountdown();
  window.addEventListener('cart_changed', () => {
    startCountdown();
  });
});
